import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = {
  key: 1,
  class: "container"
}
const _hoisted_3 = { class: "navbar fixed-bottom navbar-dark bg-dark" }
const _hoisted_4 = { class: "container d-flex justify-content-center" }
const _hoisted_5 = {
  class: "btn-group",
  role: "group"
}
const _hoisted_6 = { class: "btn btn-secondary" }
const _hoisted_7 = { class: "btn btn-secondary" }
const _hoisted_8 = { class: "navbar navbar-expand-md navbar-dark bg-dark fixed-top" }
const _hoisted_9 = { class: "container" }
const _hoisted_10 = { class: "btn btn-light mr-auto" }
const _hoisted_11 = {
  class: "progress mx-2 w-50",
  style: {"height":"38px","background-color":"#D3D3D3"}
}
const _hoisted_12 = { style: {"padding-top":"80px","padding-bottom":"120px"} }
const _hoisted_13 = {
  id: "top",
  class: "mt-4"
}
const _hoisted_14 = { class: "navbar navbar-expand-md navbar-light bg-light" }
const _hoisted_15 = { class: "navbar-nav" }
const _hoisted_16 = { class: "nav-item dropdown" }
const _hoisted_17 = {
  class: "nav-link dropdown-toggle",
  role: "button",
  "data-toggle": "dropdown"
}
const _hoisted_18 = { class: "dropdown-menu" }
const _hoisted_19 = { class: "badge badge-secondary" }
const _hoisted_20 = { class: "badge badge-secondary" }
const _hoisted_21 = { class: "badge badge-secondary" }
const _hoisted_22 = { class: "badge badge-secondary" }
const _hoisted_23 = { class: "badge badge-secondary" }
const _hoisted_24 = { class: "nav-item dropdown" }
const _hoisted_25 = { class: "dropdown-menu" }
const _hoisted_26 = {
  key: 0,
  class: "m-4"
}
const _hoisted_27 = {
  key: 0,
  class: "px-2"
}
const _hoisted_28 = ["onClick"]
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "form-inline my-2 my-lg-0 ml-auto" }
const _hoisted_31 = ["id"]
const _hoisted_32 = { class: "mt-5 mb-3 lead" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = ["onClick"]
const _hoisted_35 = {
  class: "btn-group-vertical d-flex",
  role: "group"
}
const _hoisted_36 = {
  class: "btn-group",
  role: "group"
}
const _hoisted_37 = {
  type: "button",
  "data-toggle": "dropdown",
  class: "btn text-left btn-primary",
  style: {"padding":"0.75rem 1.25rem"}
}
const _hoisted_38 = { class: "badge badge-pill badge-light text-primary" }
const _hoisted_39 = { class: "dropdown-menu" }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = ["onClick"]
const _hoisted_42 = ["onClick"]
const _hoisted_43 = ["onClick"]
const _hoisted_44 = ["onClick"]
const _hoisted_45 = ["onClick"]
const _hoisted_46 = ["onClick"]
const _hoisted_47 = ["onClick"]
const _hoisted_48 = ["onClick"]
const _hoisted_49 = {
  type: "button",
  "data-toggle": "dropdown",
  class: "btn text-left btn-outline-secondary",
  style: {"padding":"0.75rem 1.25rem"}
}
const _hoisted_50 = { class: "dropdown-menu" }
const _hoisted_51 = ["onClick"]
const _hoisted_52 = ["onClick"]
const _hoisted_53 = ["onClick"]
const _hoisted_54 = ["onClick"]
const _hoisted_55 = ["onClick"]
const _hoisted_56 = ["onClick"]
const _hoisted_57 = ["onClick"]
const _hoisted_58 = ["onClick"]
const _hoisted_59 = ["onClick"]
const _hoisted_60 = ["onClick"]
const _hoisted_61 = {
  class: "btn-group",
  role: "group"
}
const _hoisted_62 = {
  type: "button",
  class: "btn btn-primary text-left",
  "data-toggle": "dropdown",
  style: {"padding":"0.75rem 1.25rem"}
}
const _hoisted_63 = { class: "badge badge-pill badge-light text-primary" }
const _hoisted_64 = { class: "dropdown-menu" }
const _hoisted_65 = ["onClick"]
const _hoisted_66 = ["onClick"]
const _hoisted_67 = ["onClick"]
const _hoisted_68 = ["onClick"]
const _hoisted_69 = ["onClick"]
const _hoisted_70 = ["onClick"]
const _hoisted_71 = ["onClick"]
const _hoisted_72 = ["onClick"]
const _hoisted_73 = ["onClick"]
const _hoisted_74 = {
  type: "button",
  class: "btn btn-outline-secondary text-left",
  "data-toggle": "dropdown",
  style: {"padding":"0.75rem 1.25rem"}
}
const _hoisted_75 = { class: "dropdown-menu" }
const _hoisted_76 = ["onClick"]
const _hoisted_77 = ["onClick"]
const _hoisted_78 = ["onClick"]
const _hoisted_79 = ["onClick"]
const _hoisted_80 = ["onClick"]
const _hoisted_81 = ["onClick"]
const _hoisted_82 = ["onClick"]
const _hoisted_83 = ["onClick"]
const _hoisted_84 = ["value", "onInput"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CriterionDetailsDialog = _resolveComponent("CriterionDetailsDialog")!
  const _directive_sanitizedHref = _resolveDirective("sanitizedHref")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_CriterionDetailsDialog, { viewModel: _ctx.criterionDetailsDialog }, null, 8 /* PROPS */, ["viewModel"]),
    (_ctx.initialized === false)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[15] || (_cache[15] = [
          _createElementVNode("h3", { class: "text-center" }, [
            _createElementVNode("i", { class: "fa fa-spinner fa-spin" }),
            _createTextVNode(" Loading...")
          ], -1 /* CACHED */)
        ]))]))
      : _createCommentVNode("v-if", true),
    (_ctx.initialized === true)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("nav", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_6, [...(_cache[16] || (_cache[16] = [
                  _createElementVNode("i", {
                    class: "fa fa-angle-double-left",
                    "aria-hidden": "true"
                  }, null, -1 /* CACHED */),
                  _createTextVNode(" Prev ", -1 /* CACHED */),
                  _createElementVNode("span", { class: "d-none d-sm-inline" }, "criterion", -1 /* CACHED */)
                ]))])), [
                  [_directive_sanitizedHref, _ctx.rm.PrevContextUrl]
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-warning",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.scrollTop && _ctx.scrollTop(...args)))
                }, "Back to Top"),
                _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_7, [...(_cache[17] || (_cache[17] = [
                  _createTextVNode(" Next ", -1 /* CACHED */),
                  _createElementVNode("span", { class: "d-none d-sm-inline" }, "criterion", -1 /* CACHED */),
                  _createTextVNode(),
                  _createElementVNode("i", {
                    class: "fa fa-angle-double-right",
                    "aria-hidden": "true"
                  }, null, -1 /* CACHED */)
                ]))])), [
                  [_directive_sanitizedHref, _ctx.rm.NextContextUrl]
                ])
              ])
            ])
          ]),
          _createElementVNode("nav", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_10, [...(_cache[18] || (_cache[18] = [
                _createElementVNode("i", {
                  class: "fa fa-angle-double-left",
                  "aria-hidden": "true"
                }, null, -1 /* CACHED */),
                _createTextVNode(" My Survey ", -1 /* CACHED */)
              ]))])), [
                [_directive_sanitizedHref, _ctx.rm.DashboardUrl]
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", {
                  class: "progress-bar",
                  role: "progressbar",
                  style: _normalizeStyle({'width': _ctx.Progress + '%'})
                }, _toDisplayString(_ctx.ProgressStr), 5 /* TEXT, STYLE */)
              ]),
              (_ctx.IsSaved == null)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-warning",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleSavePanelistCriterionVotesCommand && _ctx.handleSavePanelistCriterionVotesCommand(...args)))
                  }, [...(_cache[19] || (_cache[19] = [
                    _createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1 /* CACHED */),
                    _createTextVNode(" Saving... ", -1 /* CACHED */)
                  ]))]))
                : _createCommentVNode("v-if", true),
              (_ctx.IsSaved === true)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    type: "button",
                    class: "btn btn-light",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleSavePanelistCriterionVotesCommand && _ctx.handleSavePanelistCriterionVotesCommand(...args)))
                  }, " Saved "))
                : _createCommentVNode("v-if", true),
              (_ctx.IsSaved === false)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    type: "button",
                    class: "btn btn-warning",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleSavePanelistCriterionVotesCommand && _ctx.handleSavePanelistCriterionVotesCommand(...args)))
                  }, " Save "))
                : _createCommentVNode("v-if", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("h3", _hoisted_13, [
              _cache[20] || (_cache[20] = _createElementVNode("span", { class: "font-weight-light" }, "Compare criteria in the context of:", -1 /* CACHED */)),
              _createTextVNode(" " + _toDisplayString(_ctx.rm.Name), 1 /* TEXT */)
            ]),
            _cache[57] || (_cache[57] = _createElementVNode("hr", null, null, -1 /* CACHED */)),
            _createElementVNode("nav", _hoisted_14, [
              _createElementVNode("ul", _hoisted_15, [
                _createElementVNode("li", _hoisted_16, [
                  _createElementVNode("a", _hoisted_17, " Questions: " + _toDisplayString(_ctx.questionsFilter ?? 'All'), 1 /* TEXT */),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("a", {
                      class: "dropdown-item",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.questionsFilter = null))
                    }, [
                      _cache[21] || (_cache[21] = _createTextVNode("All ", -1 /* CACHED */)),
                      _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.QuestionsCount), 1 /* TEXT */)
                    ]),
                    _cache[26] || (_cache[26] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                    _createElementVNode("a", {
                      class: "dropdown-item",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.questionsFilter = 'Answered'))
                    }, [
                      _cache[22] || (_cache[22] = _createTextVNode("Answered ", -1 /* CACHED */)),
                      _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.AnsweredQuestionsCount), 1 /* TEXT */)
                    ]),
                    _createElementVNode("a", {
                      class: "dropdown-item",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.questionsFilter = 'Not answered'))
                    }, [
                      _cache[23] || (_cache[23] = _createTextVNode("Not answered ", -1 /* CACHED */)),
                      _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.NotAnsweredQuestionsCount), 1 /* TEXT */)
                    ]),
                    _cache[27] || (_cache[27] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                    _createElementVNode("a", {
                      class: "dropdown-item",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.questionsFilter = 'Commented'))
                    }, [
                      _cache[24] || (_cache[24] = _createTextVNode("Commented ", -1 /* CACHED */)),
                      _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.CommentedQuestionsCount), 1 /* TEXT */)
                    ]),
                    _createElementVNode("a", {
                      class: "dropdown-item",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.questionsFilter = 'Not commented'))
                    }, [
                      _cache[25] || (_cache[25] = _createTextVNode("Not commented ", -1 /* CACHED */)),
                      _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.NotCommentedQuestionsCount), 1 /* TEXT */)
                    ])
                  ])
                ]),
                _createElementVNode("li", _hoisted_24, [
                  _createElementVNode("a", {
                    class: "nav-link dropdown-toggle",
                    role: "button",
                    "data-toggle": "dropdown",
                    onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.loadConsistencyAnalysis && _ctx.loadConsistencyAnalysis(...args)))
                  }, " Most inconsistent "),
                  _createElementVNode("div", _hoisted_25, [
                    (_ctx.rm.ConsistencyAnalysis == null)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_26, [...(_cache[28] || (_cache[28] = [
                          _createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1 /* CACHED */)
                        ]))]))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          (_ctx.InsufficientData === true)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_27, "Not enough answers to check consistency"))
                            : _createCommentVNode("v-if", true),
                          (_ctx.IsConsistent === true)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                class: "dropdown-item",
                                onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.showConsistencyAnalysisLegend && _ctx.showConsistencyAnalysisLegend(...args)))
                              }, [
                                _cache[29] || (_cache[29] = _createElementVNode("span", { class: "fa-stack fa-lg fa-stack-sm" }, [
                                  _createElementVNode("i", { class: "fa fa-circle fa-stack-1x text-success" }),
                                  _createElementVNode("i", { class: "fa-regular fa-face-smile fa-stack-1x" })
                                ], -1 /* CACHED */)),
                                _createTextVNode(" Inconsistency score: " + _toDisplayString(_ctx.rm.ConsistencyAnalysis.CR) + "% ", 1 /* TEXT */)
                              ]))
                            : _createCommentVNode("v-if", true),
                          (_ctx.IsAcceptable === true)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.MostInconsistent, (q) => {
                                  return (_openBlock(), _createElementBlock("a", {
                                    key: q.Id,
                                    class: "dropdown-item",
                                    onClick: ($event: any) => (_ctx.highlightQuestion(q))
                                  }, _toDisplayString(q.Name1) + " vs. " + _toDisplayString(q.Name2), 9 /* TEXT, PROPS */, _hoisted_28))
                                }), 128 /* KEYED_FRAGMENT */)),
                                _cache[31] || (_cache[31] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                                _createElementVNode("a", {
                                  class: "dropdown-item",
                                  onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.showConsistencyAnalysisLegend && _ctx.showConsistencyAnalysisLegend(...args)))
                                }, [
                                  _cache[30] || (_cache[30] = _createElementVNode("span", { class: "fa-stack fa-lg fa-stack-sm" }, [
                                    _createElementVNode("i", { class: "fa fa-circle fa-stack-1x text-warning" }),
                                    _createElementVNode("i", { class: "fa-regular fa-face-meh fa-stack-1x" })
                                  ], -1 /* CACHED */)),
                                  _createTextVNode(" Inconsistency score: " + _toDisplayString(_ctx.rm.ConsistencyAnalysis.CR) + "% ", 1 /* TEXT */)
                                ])
                              ], 64 /* STABLE_FRAGMENT */))
                            : _createCommentVNode("v-if", true),
                          (_ctx.IsInconsistent === true)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.MostInconsistent, (q) => {
                                  return (_openBlock(), _createElementBlock("a", {
                                    key: q.Id,
                                    class: "dropdown-item",
                                    onClick: ($event: any) => (_ctx.highlightQuestion(q))
                                  }, _toDisplayString(q.Name1) + " vs. " + _toDisplayString(q.Name2), 9 /* TEXT, PROPS */, _hoisted_29))
                                }), 128 /* KEYED_FRAGMENT */)),
                                _cache[33] || (_cache[33] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                                _createElementVNode("a", {
                                  class: "dropdown-item",
                                  onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.showConsistencyAnalysisLegend && _ctx.showConsistencyAnalysisLegend(...args)))
                                }, [
                                  _cache[32] || (_cache[32] = _createElementVNode("span", { class: "fa-stack fa-lg fa-stack-sm" }, [
                                    _createElementVNode("i", { class: "fa fa-circle fa-stack-1x text-danger" }),
                                    _createElementVNode("i", { class: "fa-regular fa-face-frown fa-stack-1x" })
                                  ], -1 /* CACHED */)),
                                  _createTextVNode(" Inconsistency score: " + _toDisplayString(_ctx.rm.ConsistencyAnalysis.CR) + "% ", 1 /* TEXT */)
                                ])
                              ], 64 /* STABLE_FRAGMENT */))
                            : _createCommentVNode("v-if", true)
                        ], 64 /* STABLE_FRAGMENT */))
                  ])
                ])
              ]),
              _createElementVNode("form", _hoisted_30, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-control mr-sm-2",
                  type: "search",
                  placeholder: "Filter...",
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.searchPhrase) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, _ctx.searchPhrase]
                ])
              ])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.QuestionsView, (q) => {
              return (_openBlock(), _createElementBlock("div", {
                key: q.QuestionId,
                class: "row justify-content-start",
                id: _ctx.getDomId(q)
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["col-md-8 col-sm-12", {'bg-warning': q.Highlighted}])
                }, [
                  _createElementVNode("p", _hoisted_32, [
                    _createElementVNode("strong", null, _toDisplayString(q.OrderValue) + ".", 1 /* TEXT */),
                    _cache[34] || (_cache[34] = _createTextVNode(" In the context of ", -1 /* CACHED */)),
                    _createElementVNode("a", {
                      class: "text-dark font-italic",
                      onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.showCriterionDetails(_ctx.rm.Name, _ctx.rm.Path, _ctx.rm.Description)))
                    }, _toDisplayString(_ctx.rm.Name), 1 /* TEXT */),
                    _cache[35] || (_cache[35] = _createTextVNode(", which criterion is more important: ", -1 /* CACHED */)),
                    _cache[36] || (_cache[36] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                    _createElementVNode("a", {
                      class: "text-primary",
                      onClick: ($event: any) => (_ctx.showCriterionDetails(q.Name1, q.Path1, q.Description1))
                    }, _toDisplayString(q.Name1), 9 /* TEXT, PROPS */, _hoisted_33),
                    _cache[37] || (_cache[37] = _createTextVNode(" or ", -1 /* CACHED */)),
                    _createElementVNode("a", {
                      class: "text-primary",
                      onClick: ($event: any) => (_ctx.showCriterionDetails(q.Name2, q.Path2, q.Description2))
                    }, _toDisplayString(q.Name2), 9 /* TEXT, PROPS */, _hoisted_34),
                    _cache[38] || (_cache[38] = _createTextVNode("? ", -1 /* CACHED */))
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("div", _hoisted_36, [
                        (q.Value > 1.0)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createElementVNode("button", _hoisted_37, [
                                _createElementVNode("span", _hoisted_38, [
                                  _cache[39] || (_cache[39] = _createElementVNode("i", {
                                    class: "fa fa-check",
                                    "aria-hidden": "true"
                                  }, null, -1 /* CACHED */)),
                                  _createElementVNode("span", null, _toDisplayString(_ctx.getScaleLabel(q.Value)), 1 /* TEXT */)
                                ]),
                                _createElementVNode("span", null, _toDisplayString(q.Name1), 1 /* TEXT */)
                              ]),
                              _createElementVNode("div", _hoisted_39, [
                                _cache[41] || (_cache[41] = _createElementVNode("h4", { class: "dropdown-header" }, "How much more important?", -1 /* CACHED */)),
                                _cache[42] || (_cache[42] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                                _createElementVNode("a", {
                                  class: "dropdown-item",
                                  onClick: ($event: any) => (_ctx.SetValueCommand(q, 2))
                                }, "Weak", 8 /* PROPS */, _hoisted_40),
                                _createElementVNode("a", {
                                  class: "dropdown-item",
                                  onClick: ($event: any) => (_ctx.SetValueCommand(q, 3))
                                }, "Moderate", 8 /* PROPS */, _hoisted_41),
                                _createElementVNode("a", {
                                  class: "dropdown-item",
                                  onClick: ($event: any) => (_ctx.SetValueCommand(q, 4))
                                }, "Moderate +", 8 /* PROPS */, _hoisted_42),
                                _createElementVNode("a", {
                                  class: "dropdown-item",
                                  onClick: ($event: any) => (_ctx.SetValueCommand(q, 5))
                                }, "Strong", 8 /* PROPS */, _hoisted_43),
                                _createElementVNode("a", {
                                  class: "dropdown-item",
                                  onClick: ($event: any) => (_ctx.SetValueCommand(q, 6))
                                }, "Strong +", 8 /* PROPS */, _hoisted_44),
                                _createElementVNode("a", {
                                  class: "dropdown-item",
                                  onClick: ($event: any) => (_ctx.SetValueCommand(q, 7))
                                }, "Very strong", 8 /* PROPS */, _hoisted_45),
                                _createElementVNode("a", {
                                  class: "dropdown-item",
                                  onClick: ($event: any) => (_ctx.SetValueCommand(q, 8))
                                }, "Very strong +", 8 /* PROPS */, _hoisted_46),
                                _createElementVNode("a", {
                                  class: "dropdown-item",
                                  onClick: ($event: any) => (_ctx.SetValueCommand(q, 9))
                                }, "Extreme", 8 /* PROPS */, _hoisted_47),
                                _cache[43] || (_cache[43] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                                _createElementVNode("a", {
                                  class: "dropdown-item",
                                  onClick: ($event: any) => (_ctx.SetValueCommand(q, null))
                                }, [...(_cache[40] || (_cache[40] = [
                                  _createElementVNode("i", {
                                    class: "fa fa-times text-danger",
                                    "aria-hidden": "true"
                                  }, null, -1 /* CACHED */),
                                  _createTextVNode(" Clear ", -1 /* CACHED */)
                                ]))], 8 /* PROPS */, _hoisted_48)
                              ])
                            ], 64 /* STABLE_FRAGMENT */))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createElementVNode("button", _hoisted_49, [
                                _cache[44] || (_cache[44] = _createElementVNode("i", {
                                  class: "fa fa-circle-thin",
                                  "aria-hidden": "true"
                                }, null, -1 /* CACHED */)),
                                _createElementVNode("span", null, _toDisplayString(q.Name1), 1 /* TEXT */)
                              ]),
                              _createElementVNode("div", _hoisted_50, [
                                _cache[45] || (_cache[45] = _createElementVNode("h4", { class: "dropdown-header" }, "How much more important?", -1 /* CACHED */)),
                                _cache[46] || (_cache[46] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                                _createElementVNode("a", {
                                  class: "dropdown-item",
                                  onClick: ($event: any) => (_ctx.SetValueCommand(q, 2))
                                }, "Weak", 8 /* PROPS */, _hoisted_51),
                                _createElementVNode("a", {
                                  class: "dropdown-item",
                                  onClick: ($event: any) => (_ctx.SetValueCommand(q, 3))
                                }, "Moderate", 8 /* PROPS */, _hoisted_52),
                                _createElementVNode("a", {
                                  class: "dropdown-item",
                                  onClick: ($event: any) => (_ctx.SetValueCommand(q, 4))
                                }, "Moderate +", 8 /* PROPS */, _hoisted_53),
                                _createElementVNode("a", {
                                  class: "dropdown-item",
                                  onClick: ($event: any) => (_ctx.SetValueCommand(q, 5))
                                }, "Strong", 8 /* PROPS */, _hoisted_54),
                                _createElementVNode("a", {
                                  class: "dropdown-item",
                                  onClick: ($event: any) => (_ctx.SetValueCommand(q, 6))
                                }, "Strong +", 8 /* PROPS */, _hoisted_55),
                                _createElementVNode("a", {
                                  class: "dropdown-item",
                                  onClick: ($event: any) => (_ctx.SetValueCommand(q, 7))
                                }, "Very strong", 8 /* PROPS */, _hoisted_56),
                                _createElementVNode("a", {
                                  class: "dropdown-item",
                                  onClick: ($event: any) => (_ctx.SetValueCommand(q, 8))
                                }, "Very strong +", 8 /* PROPS */, _hoisted_57),
                                _createElementVNode("a", {
                                  class: "dropdown-item",
                                  onClick: ($event: any) => (_ctx.SetValueCommand(q, 9))
                                }, "Extreme", 8 /* PROPS */, _hoisted_58)
                              ])
                            ], 64 /* STABLE_FRAGMENT */))
                      ]),
                      (q.Value === 1.0)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "btn btn-primary text-left",
                            onClick: ($event: any) => (_ctx.SetValueCommand(q, null)),
                            style: {"padding":"0.75rem 1.25rem"}
                          }, [...(_cache[47] || (_cache[47] = [
                            _createElementVNode("i", { class: "fa fa-check-circle" }, null, -1 /* CACHED */),
                            _createTextVNode(" Equally important ", -1 /* CACHED */)
                          ]))], 8 /* PROPS */, _hoisted_59))
                        : (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            type: "button",
                            class: "btn btn-outline-secondary text-left",
                            onClick: ($event: any) => (_ctx.SetValueCommand(q, 1.0)),
                            style: {"padding":"0.75rem 1.25rem"}
                          }, [...(_cache[48] || (_cache[48] = [
                            _createElementVNode("i", { class: "fa fa-circle-thin" }, null, -1 /* CACHED */),
                            _createTextVNode(" Equally important ", -1 /* CACHED */)
                          ]))], 8 /* PROPS */, _hoisted_60)),
                      _createElementVNode("div", _hoisted_61, [
                        (q.Value != null && q.Value < 1.0)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createElementVNode("button", _hoisted_62, [
                                _createElementVNode("span", _hoisted_63, [
                                  _cache[49] || (_cache[49] = _createElementVNode("i", {
                                    class: "fa fa-check",
                                    "aria-hidden": "true"
                                  }, null, -1 /* CACHED */)),
                                  _createElementVNode("span", null, _toDisplayString(_ctx.getScaleLabel(q.Value)), 1 /* TEXT */)
                                ]),
                                _createElementVNode("span", null, _toDisplayString(q.Name2), 1 /* TEXT */)
                              ]),
                              _createElementVNode("div", _hoisted_64, [
                                _cache[51] || (_cache[51] = _createElementVNode("h4", { class: "dropdown-header" }, "How much more important?", -1 /* CACHED */)),
                                _cache[52] || (_cache[52] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                                _createElementVNode("a", {
                                  class: "dropdown-item",
                                  onClick: ($event: any) => (_ctx.SetValueCommand(q, 1.0/2.0))
                                }, "Weak", 8 /* PROPS */, _hoisted_65),
                                _createElementVNode("a", {
                                  class: "dropdown-item",
                                  onClick: ($event: any) => (_ctx.SetValueCommand(q, 1.0/3.0))
                                }, "Moderate", 8 /* PROPS */, _hoisted_66),
                                _createElementVNode("a", {
                                  class: "dropdown-item",
                                  onClick: ($event: any) => (_ctx.SetValueCommand(q, 1.0/4.0))
                                }, "Moderate +", 8 /* PROPS */, _hoisted_67),
                                _createElementVNode("a", {
                                  class: "dropdown-item",
                                  onClick: ($event: any) => (_ctx.SetValueCommand(q, 1.0/5.0))
                                }, "Strong", 8 /* PROPS */, _hoisted_68),
                                _createElementVNode("a", {
                                  class: "dropdown-item",
                                  onClick: ($event: any) => (_ctx.SetValueCommand(q, 1.0/6.0))
                                }, "Strong +", 8 /* PROPS */, _hoisted_69),
                                _createElementVNode("a", {
                                  class: "dropdown-item",
                                  onClick: ($event: any) => (_ctx.SetValueCommand(q, 1.0/7.0))
                                }, "Very strong", 8 /* PROPS */, _hoisted_70),
                                _createElementVNode("a", {
                                  class: "dropdown-item",
                                  onClick: ($event: any) => (_ctx.SetValueCommand(q, 1.0/8.0))
                                }, "Very strong +", 8 /* PROPS */, _hoisted_71),
                                _createElementVNode("a", {
                                  class: "dropdown-item",
                                  onClick: ($event: any) => (_ctx.SetValueCommand(q, 1.0/9.0))
                                }, "Extreme", 8 /* PROPS */, _hoisted_72),
                                _cache[53] || (_cache[53] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                                _createElementVNode("a", {
                                  class: "dropdown-item",
                                  onClick: ($event: any) => (_ctx.SetValueCommand(q, null))
                                }, [...(_cache[50] || (_cache[50] = [
                                  _createElementVNode("i", {
                                    class: "fa fa-times text-danger",
                                    "aria-hidden": "true"
                                  }, null, -1 /* CACHED */),
                                  _createTextVNode(" Clear ", -1 /* CACHED */)
                                ]))], 8 /* PROPS */, _hoisted_73)
                              ])
                            ], 64 /* STABLE_FRAGMENT */))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createElementVNode("button", _hoisted_74, [
                                _cache[54] || (_cache[54] = _createElementVNode("i", {
                                  class: "fa fa-circle-thin",
                                  "aria-hidden": "true"
                                }, null, -1 /* CACHED */)),
                                _createElementVNode("span", null, _toDisplayString(q.Name2), 1 /* TEXT */)
                              ]),
                              _createElementVNode("div", _hoisted_75, [
                                _cache[55] || (_cache[55] = _createElementVNode("h4", { class: "dropdown-header" }, "How much more important?", -1 /* CACHED */)),
                                _cache[56] || (_cache[56] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                                _createElementVNode("a", {
                                  class: "dropdown-item",
                                  onClick: ($event: any) => (_ctx.SetValueCommand(q, 1.0/2.0))
                                }, "Weak", 8 /* PROPS */, _hoisted_76),
                                _createElementVNode("a", {
                                  class: "dropdown-item",
                                  onClick: ($event: any) => (_ctx.SetValueCommand(q, 1.0/3.0))
                                }, "Moderate", 8 /* PROPS */, _hoisted_77),
                                _createElementVNode("a", {
                                  class: "dropdown-item",
                                  onClick: ($event: any) => (_ctx.SetValueCommand(q, 1.0/4.0))
                                }, "Moderate +", 8 /* PROPS */, _hoisted_78),
                                _createElementVNode("a", {
                                  class: "dropdown-item",
                                  onClick: ($event: any) => (_ctx.SetValueCommand(q, 1.0/5.0))
                                }, "Strong", 8 /* PROPS */, _hoisted_79),
                                _createElementVNode("a", {
                                  class: "dropdown-item",
                                  onClick: ($event: any) => (_ctx.SetValueCommand(q, 1.0/6.0))
                                }, "Strong +", 8 /* PROPS */, _hoisted_80),
                                _createElementVNode("a", {
                                  class: "dropdown-item",
                                  onClick: ($event: any) => (_ctx.SetValueCommand(q, 1.0/7.0))
                                }, "Very strong", 8 /* PROPS */, _hoisted_81),
                                _createElementVNode("a", {
                                  class: "dropdown-item",
                                  onClick: ($event: any) => (_ctx.SetValueCommand(q, 1.0/8.0))
                                }, "Very strong +", 8 /* PROPS */, _hoisted_82),
                                _createElementVNode("a", {
                                  class: "dropdown-item",
                                  onClick: ($event: any) => (_ctx.SetValueCommand(q, 1.0/9.0))
                                }, "Extreme", 8 /* PROPS */, _hoisted_83)
                              ])
                            ], 64 /* STABLE_FRAGMENT */))
                      ])
                    ]),
                    _createElementVNode("textarea", {
                      rows: "3",
                      value: q.Comment,
                      onInput: ($event: any) => (_ctx.setComment($event.target.value, q)),
                      class: "form-control my-3",
                      placeholder: "Comment..."
                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_84),
                    _createCommentVNode("<textarea rows=\"3\" v-model.trim=\"q.Comment\" class=\"form-control my-3\" placeholder=\"Comment...\"></textarea>")
                  ])
                ], 2 /* CLASS */)
              ], 8 /* PROPS */, _hoisted_31))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}